<app-dashboard-container
	class="dashboard-aanwezigheid-statistieken"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilters(), $event)"
	[customExportItems]="getCustomExportItemsAsArray()"
>
	<app-filter-panel
		[defaultFilters]="defaultFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/aanwezigheid"
		[permanentFilterExpressions]="permanentFilters()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-legenda class="right" [attribute]="['aw_fun_nm_interventielaag']" [keyIsClassName]="true"></app-legenda>
		<div class="container">
			<div class="row">
				<app-aanwezigheid-per-maand
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					(dataRootSelectionChange)="onDataRootSelectionChange($event)"
					(loadingChanged)="customExportItems.aanwezigheidPerMaand.setLoading($event)"
					[attr.data-exportable]="customExportItems.aanwezigheidPerMaand.condition() ? 'true' : null"
				></app-aanwezigheid-per-maand>
				<app-aanwezigheid-redenen
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					(loadingChanged)="customExportItems.afwezigheidsredenen.setLoading($event)"
					[attr.data-exportable]="customExportItems.afwezigheidsredenen.condition() ? 'true' : null"
					[leerlingDetails]="false"
				></app-aanwezigheid-redenen>
			</div>
			<div class="row">
				<app-aanwezigheid-per-schooldag
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					(loadingChanged)="customExportItems.aanwezigheidPerSchooldag.setLoading($event)"
					[attr.data-exportable]="customExportItems.aanwezigheidPerSchooldag.condition() ? 'true' : null"
				></app-aanwezigheid-per-schooldag>
				<app-aanwezigheid-per-lesuur
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					(loadingChanged)="customExportItems.aanwezigheidPerLesuur.setLoading($event)"
					[attr.data-exportable]="customExportItems.aanwezigheidPerLesuur.condition() ? 'true' : null"
				></app-aanwezigheid-per-lesuur>
			</div>
		</div>
	</section>
</app-dashboard-container>
